import { ACFMediaSizes } from 'types/media';

export const generateImageSrcset = (props: { url: string | undefined; sizes: ACFMediaSizes | undefined }) => {
  const { url, sizes } = props;
  if (!sizes) {
    return null;
  }
  const { micro, tiny, small, medium, medium_large, standard, large, xl, xxl, xxxl } = sizes || {};
  const selectedSizes = { micro, tiny, small, medium, medium_large, standard, large, xl, xxl, xxxl };
  const selectedSizesKeys = Object.keys(selectedSizes) as (keyof ACFMediaSizes)[];

  const selectedSizesString = selectedSizesKeys.reduce((prev, curr) => {
    // @ts-ignore
    if (selectedSizes[curr]) {
      const size = sizes[curr];
      if (size !== url) {
        // @ts-ignore
        prev.push(`${size} ${sizes[`${curr}-width`]}w`);
      }
    }
    return prev;
  }, []);
  return selectedSizesString.join(', ') || null;
};
